.profileItem {
  padding: var(--spacingSm);
  flex-grow: 1;
}

.headerWrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
}

.title {
  margin-top: var(--spacingLg);
  font-size: 15px;
  line-height: 24px;
  font-weight: 800;
}

.removeButton {
  flex-shrink: 0;
}

.unbiasedToggle {
  width: 100px;
  min-width: 100px;
}
